import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { PhoneBookEntry } from '../types';
import { ContactForm } from '../components/ContactForm';
import { Loading } from '../components/ui/Loading';
import { ErrorAlert } from '../components/ui/ErrorAlert';

export const EditContact = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [contact, setContact] = useState<PhoneBookEntry | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    const load = async () => {
      const { data, error: dbError } = await supabase
        .from('phone_book')
        .select('*')
        .eq('id', id)
        .single();
      if (dbError) setError(dbError.message);
      else setContact(data as PhoneBookEntry);
      setLoading(false);
    };
    load();
  }, [id]);

  if (loading) return <Loading />;
  if (error) return <ErrorAlert message={error} onRetry={() => window.location.reload()} />;
  if (!contact) return <ErrorAlert message="Contact not found" />;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Edit Contact</h1>
        <p className="text-sm text-gray-600">Update the phone book entry.</p>
      </div>
      <ContactForm initial={contact} onSuccess={() => navigate('/phone-book')} />
    </div>
  );
};
